import { render, staticRenderFns } from "./DashboardCompanyList.vue?vue&type=template&id=867c35cc&"
import script from "./DashboardCompanyList.vue?vue&type=script&lang=ts&"
export * from "./DashboardCompanyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports